import React from 'react';
import { Container, Typography, Box, Divider, List, ListItem } from '@mui/material';
import { ServerURL } from '../server/serverUrl';

export default function PrivacyPolicy() {
    return (
        <>
            <Container  maxWidth="xl" sx={{px: { xs: 0, md: 3 }}}>
                <Box elevation={3} sx={{ padding: 4, pt: 1, marginTop: 1 }} align="left">
                    <Typography variant="h4" fontSize={22} fontWeight={600} gutterBottom align="left">
                        Privacy Policy
                    </Typography>
                    <Typography variant="body2" color="textSecondary" align="left">
                        Last Updated on January 01, 2022
                    </Typography>

                    <Divider sx={{ margin: '20px 0' }} />

                    <Typography variant="h6" fontSize={18} fontWeight={600}>Personal Information</Typography>
                    <Typography variant="body1" paragraph>
                        It contains personally identifiable information, such as your name, shipping address, email address, and telephone number, that you voluntarily give to us when you register with the site or our mobile application.
                    </Typography>

                    <Divider sx={{ margin: '20px 0' }} />

                    <Typography variant="h6" fontSize={18} fontWeight={600}>What information is, or may be, collected from you?</Typography>
                    <Typography variant="body1" paragraph>
                        Small amount of data generated by a website and saved by your web browser. It is used to identify your browser, provide analytics, remember information about you such as your language preference and your login information.
                    </Typography>

                    <Divider sx={{ margin: '20px 0' }} />

                    <Typography variant="h6" fontSize={18} fontWeight={600}>How do we collect the information?</Typography>
                    <Typography variant="body1" paragraph>
                        We collect the details from you by the form where you enter for registration and login.
                    </Typography>

                    <Divider sx={{ margin: '20px 0' }} />

                    <Typography variant="h6" fontSize={18} fontWeight={600}>How is information used?</Typography>
                    <Typography variant="body1" paragraph fontSize={16} m={0}>
                        Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience when you ask for the order of delivery option. Specifically, we may use the information collected about you via the site to:
                    </Typography>
                    <List>
                        <ListItem>Provide our products, which includes updating, securing, and troubleshooting, as well as providing support.</ListItem>
                        <ListItem>It also includes sharing data when it is required to provide the service or carry out the transactions you request.</ListItem>
                        <ListItem>Improve and develop our products.</ListItem>
                        <ListItem>Personalise our products and make recommendations.</ListItem>
                        <ListItem>Advertise and market to you, which includes sending promotional communications, targeting advertising, and presenting you with relevant offers.</ListItem>
                    </List>

                    <Divider sx={{ margin: '20px 0' }} />

                    <Typography variant="h6" fontSize={18} fontWeight={600}>With whom your information will be shared?</Typography>
                    <Typography variant="body1" paragraph>
                        Your login credentials is used only for login. Your name and contact details are used by admin to generate coupon for you. Your address and mobile number will be shared to our delivery agent if you request for delivery.
                    </Typography>

                    <Divider sx={{ margin: '20px 0' }} />

                    <Typography variant="h6" fontSize={18} fontWeight={600}>How can you correct inaccuracy in the information?</Typography>
                    <Typography variant="body1" paragraph>
                        Delivery address can be changed by user at any time. Login credentials can not be changed.
                    </Typography>

                    <Divider sx={{ margin: '20px 0' }} />

                    <Typography variant="h6" fontSize={18} fontWeight={600}>Policy Update</Typography>
                    <Typography variant="body1" paragraph>
                        We may from time to time provide enhancements or improvements to the features, functionality of the service, which may include patches bug fixes, updates upgrades and other modifications. Updates may modify or delete certain features and functionalities of the service. You agree that we have no obligation to provide any updates, or continue to provide or enable any particular features and/or functionalities of the service to you. You further agree that all updates will be deemed to constitute an integral part of the service, and subject to the terms and conditions of this agreement.
                    </Typography>

                    <Divider sx={{ margin: '20px 0' }} />

                    <Typography variant="h6" fontSize={18} fontWeight={600}>Contact Information</Typography>
                    <Typography variant="body1" paragraph>
                        {ServerURL.COMPANY_ADDRESS}<br />
                        Mobile: {ServerURL.COMPANY_MOBILE}<br />
                        Email: <a href={ServerURL.COMPANY_EMAIL}>{ServerURL.COMPANY_EMAIL}</a>
                    </Typography>
                </Box>
            </Container>
        </>
    )
};